
import { GroupResponse } from '../../models/group/group-response.model';
import {
  GROUP_LIST, GROUP_LIST_ERROR, GROUP_LIST_SUCCESS, PRODUCTS_GROUP, PRODUCTS_GROUP_ERROR, PRODUCTS_GROUP_SUCCESS
} from '../contants';

export const getGroups = (assignorGuid: string) => ({
  type: GROUP_LIST,
  payload: { assignorGuid },
});

export const getGroupsSuccess = (response: GroupResponse[]) => ({
  type: GROUP_LIST_SUCCESS,
  payload: response,
});

export const getGroupsError = (message: any) => ({
  type: GROUP_LIST_ERROR,
  payload: { message },
});

export const getProductsOfGroup = (groupId: number, assignorGuid: string) => ({
  type: PRODUCTS_GROUP,
  payload: { groupId, assignorGuid },
});

export const getProductsOfGroupSuccess = (groupId: number, productsOfGroup: number[]) => ({
  type: PRODUCTS_GROUP_SUCCESS,
  payload: { groupId, productsOfGroup },
});

export const getProductsOfGroupError = (message: any) => ({
  type: PRODUCTS_GROUP_ERROR,
  payload: { message },
});
